import {
  LayoutPagePromptManagementHeader,
  LayoutPagePromptManagementTitle,
  LayoutPagePromptManagementWrapper,
  LayoutPagePromptManagementContent
} from "./LayoutPagePromptManagement.styled";
import {observer} from "mobx-react";
import {usePromptManagementStore} from "../../hooks";
import {ActionsHeaderCreate, ActionsHeaderDetail, ActionsHeaderList} from "../ActionsHeader";
import Alerts from "../../../../../elements/v2/Alerts/Alerts";
import React, {useCallback} from "react";
import {ErrorSeverityEnum, PromptManagementSystemPagesTypes} from "../../types";
import {ConfirmDeletePromptModal} from "../ConfirmDeletePromptModal";
import {useNavigate} from "react-router-dom";
import {CannotDeletePromptModal} from "../CannotDeletePromptModal";

export const LayoutPagePromptManagement = observer(({ title = "", children }) => {
  const store = usePromptManagementStore();
  const navigate = useNavigate();
  const { currentPage, error, confirmDelete, cantDelete, agentsInUse } = store;

  const onHandleDeletePrompt = useCallback(async (value) => {
    await store.remove(value);
    if (error?.show && error?.severity === ErrorSeverityEnum.SUCCESS) {
      navigate("/v2/prompt-management-system");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store]);

  return (
    <LayoutPagePromptManagementWrapper>
      { error?.show && 
        <Alerts
          severity={error?.severity}
          width={"auto"}
          top={"61px"}
          right={"16px"}
          title={error?.title}
          message={error?.message}
          onClose={() => store.closeAlert()}
        />
      }
      <CannotDeletePromptModal isOpen={cantDelete} agents={agentsInUse} />
      <ConfirmDeletePromptModal isOpen={confirmDelete} onConfirm={(value) => onHandleDeletePrompt(value)} />
      <LayoutPagePromptManagementHeader>
        <LayoutPagePromptManagementTitle data-testid="prompt-management-system-page-title">{title}</LayoutPagePromptManagementTitle>
        {currentPage === PromptManagementSystemPagesTypes.PAGE_LIST && (<ActionsHeaderList />)}
        {currentPage === PromptManagementSystemPagesTypes.PAGE_CREATE && (<ActionsHeaderCreate />)}
        {currentPage === PromptManagementSystemPagesTypes.PAGE_EDIT && (<ActionsHeaderDetail />)}
      </LayoutPagePromptManagementHeader>
      <LayoutPagePromptManagementContent>
        {children}
      </LayoutPagePromptManagementContent>
    </LayoutPagePromptManagementWrapper>
  );
});
